import { Box, Typography } from '@mui/material';
import { Order } from '../../../interfaces/Order/Order';
import { OrderProduct } from '../../../interfaces/Order/OrderProduct';
import { sharedColors, sharedStyles } from '../../../utils/Style';
import { formatCurrency } from '../../../utils/Currency';

interface ProductRowProps {
  product: OrderProduct;
  onClick: () => void;
}

const ProductRow = (props: ProductRowProps) => {
  return (
    <Box
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        props.onClick();
      }}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Typography>{props.product.quantity}</Typography>

      {props.product.media?.coverImage ? (
        <Box
          component='img'
          src={props.product.media.coverImage}
          height='auto'
          width={100}
          sx={{ border: '1px solid #80808033', borderRadius: '10px' }}
        />
      ) : (
        <Box
          sx={{
            width: 100,
            height: 100,
            border: '1px solid #80808033',
            borderRadius: '10px',
          }}
        />
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography sx={{ ...sharedStyles.body2, fontWeight: 'bold' }}>
          {props.product.name.name}
        </Typography>

        {props.product.options.length > 0 && (
          <Typography
            sx={{ ...sharedStyles.body2, color: sharedColors.gray5, mt: -0.5 }}
          >
            {props.product.options
              .map((option) => option.optionValueName)
              .join(' / ')}
          </Typography>
        )}

        {!!props.product.sku && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 0.2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={sharedStyles.body2}>Stok Kodu:</Typography>
            <Typography
              sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}
            >
              {props.product.sku}
            </Typography>
          </Box>
        )}

        {!!props.product.barcode && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 0.2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={sharedStyles.body2}>Barkod:</Typography>
            <Typography
              sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}
            >
              {props.product.barcode}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 0.2,
            flexWrap: 'wrap',
          }}
        >
          <Typography sx={sharedStyles.body2}>Birim Fiyat:</Typography>
          <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
            {formatCurrency(props.product.companyPrice.raw)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

interface ProductsCellProps {
  order: Order;
}

export const ProductsCell = (props: ProductsCellProps) => {
  const handleClick = (productID: number) => {
    const url = `/products/catalog/${productID}`;
    window.open(url, '_blank');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        maxHeight: 250,
        overflowY: 'auto',
      }}
    >
      {props.order.products.map((product, i) => (
        <ProductRow
          key={i}
          product={product}
          onClick={() => handleClick(product.productID)}
        />
      ))}
    </Box>
  );
};
